import { render, staticRenderFns } from "./procurementDocking.vue?vue&type=template&id=55868976&scoped=true"
import script from "./procurementDocking.vue?vue&type=script&lang=js"
export * from "./procurementDocking.vue?vue&type=script&lang=js"
import style0 from "./procurementDocking.vue?vue&type=style&index=0&id=55868976&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55868976",
  null
  
)

export default component.exports